import React, { useRef, useState } from "react";
import NumberFormat from "react-number-format";
import cx from "classnames";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "./InputErrorList";
import { InputIcon } from "./InputIcon";
import "./Input.scss";
import "./MoneyInput.scss";
function localeInfo(locale) {
    var _a, _b;
    if (!locale) {
        return {
            decimalSeparator: ",",
            thousandSeparator: " ",
        };
    }
    const localeString = (12345.6789).toLocaleString(locale);
    return {
        decimalSeparator: ((_a = localeString.match(/345(.*)67/)) === null || _a === void 0 ? void 0 : _a[1]) || ".",
        thousandSeparator: ((_b = localeString.match(/12(.*)345/)) === null || _b === void 0 ? void 0 : _b[1]) || " ",
    };
}
const isAllowed = (values) => values.value === "" || (values.floatValue || 0) <= 100000000000000;
export function MoneyInput({ value = "", label, defaultValue, onChange, onBlur, placeholder, currency, locale, disabled = false, validators = [], forceValidation = false, readOnly = false, decimalScale, showPendingState = false, showSuccessState = false, }) {
    const inputName = useRef("money_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(value, validators, forceValidation, showPendingState, showSuccessState);
    useForm(inputName.current, validity, value, resetValidation, containerRef, errorMessages, label);
    const [internalValue, setInternalValue] = useState();
    const classes = cx("lysa-ui-input numeric money-input", validityClasses, {
        "lysa-ui-input-read-only": readOnly,
    });
    const { thousandSeparator, decimalSeparator } = localeInfo(locale);
    const placeholderSpan = !value && (React.createElement("span", { className: "placeholder" }, placeholder));
    const formattedInitialValue = !internalValue && value && (React.createElement(NumberFormat, { className: "money-value", defaultValue: defaultValue, value: value, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, isNumericString: true, id: inputName.current + "_currency", displayType: "text", disabled: disabled, inputMode: "decimal" }));
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group" },
        label && React.createElement("label", { htmlFor: inputName.current }, label),
        React.createElement("div", { className: classes },
            React.createElement(NumberFormat, { className: "overlay-input", defaultValue: defaultValue, value: value, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, isNumericString: true, id: inputName.current, disabled: disabled, inputMode: "decimal", readOnly: readOnly, isAllowed: isAllowed, decimalScale: decimalScale, onValueChange: (valuesObject) => {
                    onChange && onChange(valuesObject.value);
                    setInternalValue(valuesObject.formattedValue);
                }, onBlur: () => onBlur && onBlur() }),
            React.createElement("div", { className: "input-container" },
                placeholderSpan,
                formattedInitialValue,
                internalValue,
                React.createElement("span", { className: "currency" },
                    " ",
                    currency)),
            React.createElement(InputIcon, null),
            React.createElement(InputErrorList, { errorMessages: errorMessages }))));
}
